import { Home, Info, User2, Signal, History, Settings, ChartBarIcon } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { SearchForm } from "@/components/search-form";
import { NavUser } from "@/components/nav-user"
import { useNavigate } from "react-router-dom";

// Menu items.
const items = [
  {
    title: "Anomali Tespiti",
    url: "/anomalystatus",
    icon: Info,
  },
  {
    title: "Düğümlerin Durumu",
    url: "/nodestatus",
    icon: Signal,
  },
  {
    title: "Uygulama Yönetimi",
    url: "/applicationmanagement",
    icon: User2,
  },
  {
    title: "İşlem Geçmişi",
    url: "/transactionhistory",
    icon: History,
  },
];

export function AppSidebar() {
  let user = {
    name: "TUBU ARGE",
    email: "tubu@tubu.io",
    avatar: "/cat.png",
  };

  try {
    const storedUser = localStorage.getItem("auth_user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      user = {
        ...user,
        name: parsed.first_name && parsed.last_name ? `${parsed.first_name} ${parsed.last_name}` : (parsed.name || user.name),
        email: parsed.email || user.email,
      };
    }
  } catch (e) {}

  return (
    <Sidebar>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>sMPC</SidebarGroupLabel>
          <SidebarGroupContent>
            <SearchForm className="mb-2" />
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <a href={item.url}>
                      <item.icon />
                      <span>{item.title}</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup className="mt-auto">
          <SidebarGroupContent>
            <NavUser user={user} />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}